<template>
  <div class="about-us">
    <div class="about-us__top">
      <img class="about-us__top__img" src="../assets/image/aboutUs_1.png" alt="">
      <div class="about-us__top__text1">与主机厂合作，进行深度绑定</div>
      <div class="about-us__top__text2">COOPERATE WITH OEMS FOR DEEP BINDING</div>
    </div>
    <div class="about-us__middle">
      <div class="about-us__middle__title">
        <p>公司简介</p>
        <p>COMPANY PROFILE</p>
      </div>
      <div class="about-us__middle__text">
        <p>
          上海越联信息科技有限公司成立于2020年12月，总部位于上海市，是聚焦互联网新能源出行市场一站式数字化零售运营解决方案提供商。<br> 
          用全新的视角探索行业趋势现状与机遇发展，通过自拓市场渠道、品牌产品定制合作、终端门店OMO营销赋能、全数字化运营管理，为车企品牌商、经销商、终端用户等提供智能数字营销策划和交付服务，打造新能源交通工具领域综合垂直服务。 解决您的线上营销，品牌零售，新能源出行行业零售运营困局。<br>
          <br>
          二轮行业服务新大洲电动车与速珂电动车，新能源汽车行业服务东风新能源，提供用户端，商户端及车管家SAAS开发及日常运维服务，商品企划，内容运营，直播运营，店铺运营等数字化营销运营。<br>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AboutUs'
}
</script>

<style lang="scss" scoped>
.about-us{
  &__top{
    position: relative;
    width: 100%;
    &__img{
      width: 100%;
      min-width: 1440px;
      max-width: 1920px;
    }
    &__text1{
      width: 100%;
      position: absolute;
      text-align: center;
      color: #fff;
      font-size: 40px;
      top: 300px;
      line-height: 50px;
    }
    &__text2{
      width: 100%;
      position: absolute;
      text-align: center;
      color: #F8F8F8;
      font-size: 15px;
      top: 360px;
      line-height: 24px;
      letter-spacing:3px;
    }
  }
  &__middle{
    margin: 140px auto;
    &__title{
      font-size: 40px;
      color: #333;
      width: 880px;
      text-align: center;
      margin: 0 auto;
      height: 60px;
      position: relative;
      p:first-child{
          font-size: 40px;
          margin-bottom: -15px;
          font-family: webfont__bold;
      }
      p:last-child{
        font-size: 34px;
        opacity: 0.07;
      }
    }
    &__text{
      width: 1400px;
      margin: 72px auto;
      p{
        padding: 72px 83px;
        font-size: 16px;
        text-align: left;
        color: #666;
        background-color: #fff;
        border-radius: 20px;
        line-height: 32px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/aboutUs.vue